import { watch } from "vue";

import useFormValidation from "@/composables/validations/useFormValidation";
import usePaymentFilters from "@/composables/filters/usePaymentFilters";
import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";

const { validateFiatField, validateCoinField } = useFormValidation();
const { filterPaymentLimit } = usePaymentFilters();

export default function useTransactionalLimits() {
  const globalStore = useGlobalStore();

  /**
   * Watches form fiatamount dependcies fields: fiatType and updates the fiatAmount validator
   * @param {object} form The form that's values are being watched.
   * @param {object} store The store that the state is to be bound to.
   * @param {function} callback OPTIONAL. Callback to run when complete.
   */
  const watchAndHandleFiatValidation = (form, store) => {
    watch(
      () => [form.value.fiatType, form.value.payment],
      () => {
        if (!form.value.fiatAmount || !form.value.payment) {
          return;
        }
        const orderStore = useOrderFormStore();
        const state = store.$state.form;
        const fiatAmount = state.fiatAmount.value;
        const fiatType = state.fiatType.value;

        state.fiatAmount.error = validateFiatField(
          fiatAmount,
          fiatType,
          filterPaymentLimit(
            state.fiatType.value,
            state.payment.value,
            orderStore.getActiveStorePaymentData
          )
        );
      },
      { deep: true }
    );
  };

  /**
   * Watches form coinamount dependcies fields: coinTyoe, blockchain and updates the coinAmount validator
   * @param {object} form The form that's values are being watched.
   * @param {object} store The store that the state is to be bound to.
   */
  const watchAndHandleCoinValidation = (form, store) => {
    watch(
      () => [form.value.coinType, form.value.blockchain],
      () => {
        if (!form.value.coinAmount) {
          return;
        }

        const { data } = store.$state.coinData;
        const storeForm = store.$state.form;
        const coinAmount = storeForm.coinAmount.value;
        const blockchain = storeForm.blockchain.value;
        const coinType = storeForm.coinType.value;

        storeForm.coinAmount.error = validateCoinField(
          coinAmount,
          coinType,
          blockchain,
          data
        );
      },
      { deep: true }
    );
  };

  return {
    watchAndHandleFiatValidation,
    watchAndHandleCoinValidation,
  };
}
